const tagSession = (user) => {
    try {
        let data = {
            email: user.username,
            businessName: user.businessName,
            firstName: user.firstName,
            idBusiness: user.idBusiness,
            idUser: user.idUser,
            idCustomer: user.idCustomer
        }
        window.__insp.push(['tagSession', data]);
    } catch (inspectorError) {
        console.log(inspectorError)
    }
}

export default { tagSession }


// WEBPACK FOOTER //
// ./src/utils/inspectlet.js